import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

type SideBarProps = {
  children?: React.ReactNode;
  onHideClick?(): void;
  showSideBar: boolean;
};

const SideBar = ({ children, onHideClick, showSideBar }: SideBarProps) => {
  return (
    <>
      {onHideClick && (
        <Transition.Root show={showSideBar} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-40 lg:hidden"
            onClose={onHideClick}
          >
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-150"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-150"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
            </Transition.Child>

            <div className="fixed inset-0 flex z-40">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-150 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-150 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="relative flex flex-col bg-white md:2/3 sm:w-2/3 xs:w-11/12 rounded-tr-2xl h-full">
                  <div id="mobile-sidebar" className="overflow-y-auto">
                    {children}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>
      )}
      {/*  desktop sidebar */}
      <div
        className={`${
          onHideClick ? "hidden" : ""
        } lg:flex lg:flex-col md:inset-y-0 w-full`}
      >
        <div className="flex-1 flex flex-col min-h-0 bg-white rounded-tr-2xl">
          <div
            id="desktop-sidebar"
            className="flex-1 flex flex-col pt-5 overflow-y-auto"
          >
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
